export const TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS = {
  utm_source: "utm_source",
  utm_medium: "utm_medium",
  utm_campaign: "utm_campaign",
  utm_term: "utm_term",
  utm_content: "utm_content",
  gclid: "gclid",
  gclsrc: "gclsrc",
  dclid: "dclid",
  fbclid: "fbclid",
  wickedsource: "wickedsource",
};

export type TrafficConfigQueryParamOptionsType =
  keyof typeof TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS;

export const TRAFFIC_CONFIG_FILTER_OPTIONS = {
  equals: "equals",
  contains: "contains",
  startsWith: "starts with",
  endsWith: "ends with",
  isNull: "is not set",
  doesNotEqual: "does not equal",
  doesNotContain: "does not contain",
  doesNotStartWith: "does not start with",
  doesNotEndWith: "does not end with",
  isNotNull: "is set",
};

export const audienceTabNumberMap = {
  common: 0,
  custom: 1,
  advanced: 2,
  link: 2,
};
